import { useAction } from "./common";
import Path from "../utils/path";
import { fetchWithContext, useFetchContext } from "../plugins/fetch";
import { useMutation } from "react-query";
import _ from "lodash";

export const useBulkPauseAction = ({ onSuccess, onError }) => {
  return useAction("/workflow/bulk/pause", "put", { onSuccess, onError });
};

export const useBulkResumeAction = ({ onSuccess, onError }) => {
  return useAction("/workflow/bulk/resume", "put", { onSuccess, onError });
};

export const useBulkRestartAction = ({ onSuccess, onError }) => {
  return useAction("/workflow/bulk/restart", "post", { onSuccess, onError });
};

export const useBulkRestartLatestAction = ({ onSuccess, onError }) => {
  return useAction("/workflow/bulk/restart?useLatestDefinitions=true", "post", {
    onSuccess,
    onError,
  });
};

export const useBulkRetryAction = ({ onSuccess, onError }) => {
  return useAction("/workflow/bulk/retry", "post", { onSuccess, onError });
};

export const useBulkTerminateAction = ({ onSuccess, onError }) => {
  return useAction("/workflow/bulk/terminate", "post", { onSuccess, onError });
};

export const useBulkTerminateWithReasonAction = ({ onSuccess, onError }) => {
  const fetchContext = useFetchContext();

  return useMutation(
    (mutateParams) => {
      const path = new Path("/workflow/bulk/terminate");

      if (mutateParams.reason) {
        path.search.append("reason", mutateParams.reason);
      }

      return fetchWithContext(path, fetchContext, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: _.get(mutateParams, "body"),
      });
    },
    {
      onSuccess,
      onError,
    }
  );
};
